import { _APIHandler } from "../utils/helper";

let baseUrl = "auth";
export const signin = (data) => _APIHandler.post(`${baseUrl}/signin`, data);
export const signup = (data) => _APIHandler.post(`${baseUrl}/signup`, data);
export const verifyEmail = (token) => _APIHandler.get(`${baseUrl}/email/verify/${token}`);
export const forgotPassword = (data) => _APIHandler.post(`${baseUrl}/password/forgot`, data);
export const resetPassword = (token, data) => _APIHandler.put(`${baseUrl}/password/reset/${token}`, data);